import React from 'react';

import { InputText } from 'primereact/inputtext';

export enum ButtonType {}
const Input: React.FC<
  React.ComponentPropsWithoutRef<typeof InputText> & {
    className?: string;
    keyFilter?: string | RegExp | 'pint' | 'int' | 'pnum' | 'num' | 'email' | 'alpha' | 'alphanum';
  }
> = (props) => {
  const { keyFilter, ...rest } = props;
  return (
    <InputText
      {...rest}
      keyfilter={keyFilter}
      type={props.type || 'text'}
      name={props.name || props.id}
      className={`${props.className || ''}`}
      autoComplete={'off'}
    />
  );
};

export default Input;
